import { Component, OnInit, Input } from '@angular/core';
import { AgendaMasivaModel } from 'src/app/models/agendaMasiva.model';
import { UploadService } from 'src/app/shared/upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
declare var $: any;
@Component({
  selector: 'app-tabla-cancelar-agenda',
  templateUrl: './tabla-cancelar-agenda.component.html',
  styleUrls: ['./tabla-cancelar-agenda.component.scss']
})
export class TablaCancelarAgendaComponent implements OnInit {

  @Input() datosRegistro: AgendaMasivaModel[];
  public modalOptions: ConfirmationModalOptions;

  constructor(
    private uploadService: UploadService, private spinner: NgxSpinnerService,
    private alertService: AlertService) {
    this.modalOptions =
      new ConfirmationModalOptions('Confirmación', '¿Está seguro de cancelar las agendas?',
        'SI', 'NO', 'fas fa-trash-alt', true, false, 'Cancelar agendas', null, 'btn-secondary');
  }

  ngOnInit() {

  }

  habilitarCancelacion() {
    const marcados = this.datosRegistro.filter(dato => dato.checked);
    this.modalOptions.disabled = !this.datosRegistro || !marcados || marcados.length === 0;
  }

  seleccionarFila(index: number) {
    this.datosRegistro[index].checked = !this.datosRegistro[index].checked;
    this.habilitarCancelacion();
  }

  seleccionarTodo(estado) {
    this.datosRegistro.forEach(reg => {
      if (reg.errores.length === 0) {
        reg.checked = estado;
      }
    });
    this.habilitarCancelacion();
  }

  cancelarVisitaMasiva(): void {
    const listaEnvio = this.datosRegistro.filter(reg => reg.checked);
    this.validarSeleccionFilas(listaEnvio, this.datosRegistro.length);
  }

  getConfirmationModalResponse(event) {
    if (event[0]) {
      this.cancelarVisitaMasiva();
    }
  }

  validarSeleccionFilas(lista: AgendaMasivaModel[], totalRegistros) {
    this.spinner.show();
    this.uploadService.registrarAgendaMasiva(`/servicios/agenda/cancelarAgendasMasivas`, lista)
    .subscribe(data => {
      this.eliminarRegistrosAgenda(lista);
      this.spinner.hide();
      this.alertService
        .generateAlertSuccess(`Se cancelaron ${lista.length} agendas exitosamente de ${totalRegistros} registros incluidos en el archivo`
        , ' ');
    }, error => {
      let errorText = 'Se presentó un error al realizar la cancelación de agendas';
      if (error.error && error.error.message) {
        errorText = error.error.message;
      }
      this.spinner.hide();
      this.alertService.generateAlertError(errorText, ' ');
    });
  }

  eliminarRegistrosAgenda(agenda: AgendaMasivaModel[]) {
    agenda.forEach(a => {
      const index: number = this.datosRegistro.indexOf(a);
      if (index !== -1) {
        this.datosRegistro.splice(index, 1);
      }
    });
  }

  mostrarErrores() {
    $('#selectorArchivo').focus();
  }
}
